export default "__VITE_ASSET__a80f7fec__"